import { Button, IconOrganizationFilled24, IconOrganizationOutlined24 } from '@gmg/gmg-react-components';
import { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from 'src/AppContext';
import styled from 'styled-components';
import AddOrEditOrgModalContainer from '../sysadministration/AddOrEditOrgModalContainer';
import { Organization } from 'src/viewModels/Organization';
import InfoCard from '../shared/InfoCard';

export interface OrganizationDetailsCardProps {
    organization: Omit<Organization, 'groups' | 'rootFolders' | 'users' | 'moduleLicenses' | 'licenseSystems' | 'registration' | 'isSiteOrganization' | 'parentOrgId' | 'isHeadOrganization' | 'parentOrgData'> | undefined;
};

const OrganizationDetailsCard: FunctionComponent<OrganizationDetailsCardProps> = props => {
    const { t } = useTranslation();
    const context = useContext(AppContext);

    const handleEditOrganizationBtnClick = () => {
        context.onShowModal('inputModal', {
            title: t('AddOrEditOrgModalContainer.modal_title', 'Edit organization'),
            titleIcon: <IconOrganizationFilled24 />,
            content: <AddOrEditOrgModalContainer existingOrgNames={[]} toBeEditedOrganization={props.organization!} />,
        });
    };

    return (
        <InfoCard
            icon={<IconOrganizationOutlined24 />}
            title={props.organization?.name || 'My Organization'}
            cta={
                <Button
                    variant='primary'
                    onClick={handleEditOrganizationBtnClick}
                    disabled={!props.organization}
                    aria-label='edit organization'
                >
                    {t('NewOrgModal.action_edit_btn', 'Edit')}
                </Button>
            }
        >
            <Div>
                <p className='px12_600_normal'>{t('Details.InfoCard.orgCode_title', 'Code')}</p>
                <span className='px12_400_normal' aria-label='organization code'>
                    {props.organization?.code}
                </span>
            </Div>
            <Div>
                <p className='px12_600_normal'>{t('Details.InfoCard.orgAddress_title', 'Address')}</p>
                {props.organization && (
                    <>
                        <div className='px12_400_normal' aria-label='street of organization'>
                            {props.organization.address}
                        </div>
                        <div>
                            <span className='px12_400_normal' aria-label='city of organization'>{props.organization.city},&nbsp;</span>
                            <span className='px12_400_normal' aria-label='zip of organization'>{props.organization.zip}</span>
                        </div>
                    </>)}
            </Div>
            <Div>
                <p className='px12_600_normal'>{t('Details.InfoCard.primaryContact_title', 'Primary contact')}</p>
                <span className='px12_400_normal' aria-label='contact email'>
                    {props.organization?.contactEmail}
                </span>
            </Div>
            <Div>
                <p className='px12_600_normal'>{t('Details.InfoCard.phone_number_title', 'Phone number')}</p>
                <span className='px12_400_normal' aria-label='contact phone'>
                    {props.organization?.contactPhone || '-'}
                </span>
            </Div>
        </InfoCard>
    );
};

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export default OrganizationDetailsCard;
